/* SUN365 landing sections — shared behaviors (customizer-safe) */
(function () {
  "use strict";

  /* ---------- generic behaviors ---------- */
  function initGeneric(root) {
    // scroll reveals
    if ("IntersectionObserver" in window) {
      var obs = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("in"); obs.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      root.querySelectorAll(".reveal:not(.in), .stagger:not(.in)").forEach(function (el) { obs.observe(el); });
    } else {
      root.querySelectorAll(".reveal, .stagger").forEach(function (el) { el.classList.add("in"); });
    }

    // marquee track duplication (seamless loop)
    root.querySelectorAll("[data-ig-dup]:not([data-dup-done])").forEach(function (track) {
      track.setAttribute("data-dup-done", "1");
      var dup = document.createElement("div");
      dup.setAttribute("aria-hidden", "true");
      dup.style.display = "contents";
      dup.innerHTML = track.innerHTML;
      track.appendChild(dup);
    });

    // videos play only in view
    if ("IntersectionObserver" in window) {
      var rmStatic = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      // only Safari plays HLS natively and reliably; everyone else gets the mp4 source
      var isSafari = /^((?!chrome|android|crios|fxios|edg).)*safari/i.test(navigator.userAgent);
      root.querySelectorAll("video[data-auto]:not([data-vo])").forEach(function (v) {
        v.setAttribute("data-vo", "1");
        if (!isSafari) {
          var hls = v.querySelectorAll('source[type="application/x-mpegURL"]');
          if (hls.length) { hls.forEach(function (s) { s.remove(); }); v.load(); }
        }
        // wall videos stay on their poster for reduced-motion users
        if (rmStatic && v.hasAttribute("data-rm-static")) return;
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); }
          });
        }, { threshold: 0.25 }).observe(v);
      });
    }

    // tasting tabs
    root.querySelectorAll("[data-tab-value]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var scope = btn.closest(".s365");
        scope.querySelectorAll("[data-tab-value]").forEach(function (b) {
          b.setAttribute("aria-pressed", b === btn ? "true" : "false");
        });
        scope.querySelectorAll("[data-pane-value]").forEach(function (p) {
          p.classList.toggle("active", p.getAttribute("data-pane-value") === btn.getAttribute("data-tab-value"));
        });
      });
    });

    // quiz cards -> pick flavor in buy section + scroll to tasting
    root.querySelectorAll("[data-quiz-flavor]").forEach(function (card) {
      card.addEventListener("click", function () {
        var val = card.getAttribute("data-quiz-flavor");
        var flavorBtn = document.querySelector('.s365-buy [data-opt-value="' + CSS.escape(val) + '"]');
        if (flavorBtn) flavorBtn.click();
        var tabBtn = document.querySelector('.s365 [data-tab-value="' + CSS.escape(val) + '"]');
        if (tabBtn) tabBtn.click();
        var tasting = document.querySelector(".s365-tasting");
        if (tasting) tasting.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    // tasting notes open on the flavour picked in the buy panel (v2)
    if (!document.documentElement.hasAttribute("data-s365-tasting-sync")) {
      document.documentElement.setAttribute("data-s365-tasting-sync", "1");
      document.addEventListener("s365:variant", function (e) {
        var flavor = e.detail && e.detail.flavor;
        if (!flavor) return;
        var tab = document.querySelector('.s365-tasting [data-tab-value="' + CSS.escape(flavor) + '"]');
        if (tab && tab.getAttribute("aria-pressed") !== "true") tab.click();
      });
    }
  }

  /* ---------- parallax (init once) ---------- */
  var parallaxInit = false;
  function initParallax() {
    if (parallaxInit) return;
    parallaxInit = true;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var ticking = false;
    function choreo() {
      var vh = window.innerHeight;
      document.querySelectorAll(".s365 [data-plx]").forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var offset = (r.top + r.height / 2 - vh / 2) * parseFloat(el.getAttribute("data-plx"));
        el.style.setProperty("--py", offset.toFixed(1) + "px");
      });
      var b1 = document.querySelector(".s365 [data-band1]");
      var b2 = document.querySelector(".s365 [data-band2]");
      if (b1 && b2) {
        var r = b1.parentElement.getBoundingClientRect();
        if (r.bottom > 0 && r.top < vh) {
          var p = (vh - r.top) / (vh + r.height);
          b1.style.transform = "translateX(" + (-14 - p * 14) + "%)";
          b2.style.transform = "translateX(" + (-28 + p * 14) + "%)";
        }
      }
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(choreo); }
    }, { passive: true });
    choreo();
  }

  /* ---------- buy component (variant picker + price + gallery) ---------- */
  /* ---------- per-flavour facts accordions (v2) ---------- */
  function initFacts(buy) {
    var root = buy.querySelector("[data-facts]");
    if (!root || root.getAttribute("data-facts-init")) return;
    root.setAttribute("data-facts-init", "1");
    var discovery = root.getAttribute("data-discovery") || "";
    var pills = Array.prototype.slice.call(root.querySelectorAll("[data-facts-pill]"));
    var pick = pills.length ? pills[0].getAttribute("data-facts-pill") : "";
    function show(flavour) {
      root.querySelectorAll("[data-facts-pane]").forEach(function (p) {
        p.hidden = p.getAttribute("data-facts-pane") !== flavour;
      });
      pills.forEach(function (b) {
        b.setAttribute("aria-pressed", b.getAttribute("data-facts-pill") === flavour ? "true" : "false");
      });
    }
    function apply(flavour) {
      var isDisc = !!discovery && flavour === discovery;
      root.querySelectorAll("[data-facts-pills]").forEach(function (row) { row.hidden = !isDisc; });
      show(isDisc ? pick : flavour);
    }
    pills.forEach(function (b) {
      b.addEventListener("click", function () { pick = b.getAttribute("data-facts-pill"); show(pick); });
    });
    document.addEventListener("s365:variant", function (e) {
      if (e.detail && e.detail.flavor) apply(e.detail.flavor);
    });
  }

  /* ---------- Great Taste trio: follow the selected flavour (v2) ---------- */
  function initAwards(root) {
    root.querySelectorAll("[data-awards]:not([data-aw-init])").forEach(function (aw) {
      aw.setAttribute("data-aw-init", "1");
      var grid = aw.querySelector("[data-awards-grid]");
      var note = aw.querySelector("[data-aw-note]");
      var discovery = aw.getAttribute("data-discovery") || "";
      if (!grid) return;
      function apply(flavour) {
        var all = !!discovery && flavour === discovery;
        grid.classList.toggle("all", all);
        if (note) note.hidden = !all;
        var side = 0;
        grid.querySelectorAll(".aw-col").forEach(function (col) {
          var on = !all && col.getAttribute("data-flavour") === flavour;
          col.classList.toggle("on", on);
          if (on) { col.style.order = "2"; } else { side += 2; col.style.order = String(side - 1); }
        });
      }
      document.addEventListener("s365:variant", function (e) {
        if (e.detail && e.detail.flavor) apply(e.detail.flavor);
      });
    });
  }

  function initBuy(section) {
    var buy = section.classList && section.classList.contains("s365-buy")
      ? section
      : section.querySelector(".s365-buy");
    if (!buy || buy.getAttribute("data-buy-init")) return;
    buy.setAttribute("data-buy-init", "1");

    var dataEl = buy.querySelector("[data-s365-variants]");
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var optCount = parseInt(buy.getAttribute("data-options"), 10) || 1;
    initFacts(buy);

    function selected() {
      var sel = [];
      for (var i = 1; i <= optCount; i++) {
        var btn = buy.querySelector('[data-opt-idx="' + i + '"][aria-pressed="true"]');
        sel.push(btn ? btn.getAttribute("data-opt-value") : null);
      }
      return sel;
    }
    /* an available variant exists with option[idx]=val, honouring only EARLIER selections
       (hierarchical: Skonis constrains Dydis, Skonis+Dydis constrain Kiekis) */
    function existsAvail(sel, idx, val) {
      return variants.some(function (v) {
        if (!v.available || v["option" + idx] !== val) return false;
        for (var i = 1; i < idx; i++) {
          if (sel[i - 1] && v["option" + i] !== sel[i - 1]) return false;
        }
        return true;
      });
    }
    function setPressed(idx, val) {
      buy.querySelectorAll('[data-opt-idx="' + idx + '"]').forEach(function (b) {
        b.setAttribute("aria-pressed", b.getAttribute("data-opt-value") === val ? "true" : "false");
      });
    }
    /* after changing option changedIdx, snap each later option to a valid value */
    function cascade(changedIdx) {
      for (var j = changedIdx + 1; j <= optCount; j++) {
        var sel = selected();
        if (sel[j - 1] && existsAvail(sel, j, sel[j - 1])) continue;
        var btns = buy.querySelectorAll('[data-opt-idx="' + j + '"]');
        for (var k = 0; k < btns.length; k++) {
          var val = btns[k].getAttribute("data-opt-value");
          if (existsAvail(sel, j, val)) { setPressed(j, val); break; }
        }
      }
    }
    function findVariant(sel) {
      return variants.find(function (v) {
        for (var i = 0; i < optCount; i++) { if (v["option" + (i + 1)] !== sel[i]) return false; }
        return true;
      });
    }

    function update() {
      var sel = selected();
      var flavorName = section.querySelector("[data-flavor-name]");
      if (flavorName && sel[0]) flavorName.textContent = sel[0];
      // disable a value only when no available variant matches it plus the EARLIER selections
      buy.querySelectorAll("[data-opt-idx]").forEach(function (btn) {
        var idx = parseInt(btn.getAttribute("data-opt-idx"), 10);
        var val = btn.getAttribute("data-opt-value");
        btn.toggleAttribute("disabled", !existsAvail(sel, idx, val));
      });

      var v = findVariant(sel);
      var cta = buy.querySelector("[data-cta]");
      var priceEl = buy.querySelector("[data-price]");
      var compareEl = buy.querySelector("[data-compare]");
      var unitEl = buy.querySelector("[data-unit]");
      var idInput = buy.querySelector('input[name="id"]');
      var sbName = document.querySelector("[data-sb-name]");
      var sbPrice = document.querySelector("[data-sb-price]");

      if (v) {
        idInput.value = v.id;
        priceEl.innerHTML = v.price_html;
        if (compareEl) {
          compareEl.hidden = !v.compare_html;
          compareEl.innerHTML = v.compare_html || "";
        }
        if (unitEl) unitEl.textContent = v.unit_text || "";
        if (cta) {
          cta.setAttribute("aria-disabled", v.available ? "false" : "true");
          cta.textContent = v.available ? cta.getAttribute("data-label-add") + " — " + v.price_text
                                        : cta.getAttribute("data-label-soldout");
        }
        if (v.image) setMain(v.image, v.title);
        syncAward(sel[0]);
        if (sbName) sbName.textContent = v.title.split(" / ").join(" · ");
        if (sbPrice) sbPrice.textContent = v.price_text;
      } else if (cta) {
        cta.setAttribute("aria-disabled", "true");
        cta.textContent = cta.getAttribute("data-label-unavailable");
      }
      document.dispatchEvent(new CustomEvent("s365:variant", {
        detail: { variant: v || null, flavor: sel[0] || "", size: sel[1] || "", quantity: sel[2] || "" }
      }));
    }

    /* gallery: scroll-snap carousel (swipeable); falls back to the single
       fading image when the section renders the old markup */
    var track = section.querySelector("[data-stage-track]");
    var variantFirst = !!(track && track.getAttribute("data-gallery-mode") === "variant_first");
    var mainImg = section.querySelector("[data-main-image]");
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var firstJump = true;
    var awardSlides = {};
    var awardEl = section.querySelector("[data-s365-award-slides]");
    if (awardEl) { try { awardSlides = JSON.parse(awardEl.textContent); } catch (err) { awardSlides = {}; } }
    function slides() {
      return track ? Array.prototype.slice.call(track.children).filter(function (s) { return !s.hidden; }) : [];
    }
    function thumbs() {
      return Array.prototype.slice.call(section.querySelectorAll("[data-thumb]")).filter(function (t) { return !t.hidden; });
    }
    function markThumb(i) {
      thumbs().forEach(function (t, k) { t.classList.toggle("active", k === i); });
    }
    function currentSlide() {
      return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0;
    }
    function goTo(i, wrap, instant) {
      var list = slides();
      if (!track || !list.length) return;
      var last = list.length - 1;
      var wrapped = false;
      if (wrap) {
        // the arrows and arrow keys loop, so neither control is ever a dead end
        if (i < 0) { i = last; wrapped = true; }
        else if (i > last) { i = 0; wrapped = true; }
      } else if (i < 0 || i > last) {
        return;
      }
      // A wrap animated smoothly reads as the gallery rewinding through every slide;
      // jumping makes it read as a loop.
      var behavior = (firstJump || reduceMotion || wrapped || instant) ? "auto" : "smooth";
      track.scrollTo({ left: i * track.clientWidth, behavior: behavior });
      firstJump = false;
      markThumb(i);
    }
    function step(delta) {
      goTo(currentSlide() + delta, true);
    }
    function thumbUrl(src) { return src.replace(/([?&])width=\d+/, "$1width=128"); }
    function setRoleSlide(role, src, alt) {
      var slide = track.querySelector('[data-slide-role="' + role + '"]');
      var thumb = section.querySelector('[data-thumb-role="' + role + '"]');
      var has = !!src;
      if (slide) {
        slide.hidden = !has;
        slide.setAttribute("data-slide-src", src || "");
        var img = slide.querySelector("img");
        if (img && has && img.getAttribute("src") !== src) { img.src = src; if (alt) img.alt = alt; }
      }
      if (thumb) {
        thumb.hidden = !has;
        thumb.setAttribute("data-thumb", src || "");
        var timg = thumb.querySelector("img");
        if (timg && has) timg.src = thumbUrl(src);
      }
      var row = section.querySelector("[data-thumbs]");
      if (row) row.hidden = thumbs().length <= 1;
      syncNav();
    }
    function setMain(src, alt) {
      if (track && variantFirst) {
        setRoleSlide("variant", src, alt);
        goTo(0);
        return;
      }
      if (track) {
        var list = slides();
        for (var i = 0; i < list.length; i++) {
          if (list[i].getAttribute("data-slide-src") === src) { goTo(i); return; }
        }
        var cur = list[currentSlide()];
        var img = cur && cur.querySelector("img");
        if (img && img.getAttribute("src") !== src) { img.src = src; if (alt) img.alt = alt; }
        return;
      }
      if (!mainImg || mainImg.getAttribute("src") === src) return;
      mainImg.style.opacity = 0;
      setTimeout(function () { mainImg.src = src; if (alt) mainImg.alt = alt; mainImg.style.opacity = 1; }, 180);
    }
    function syncAward(flavour) {
      if (!track || !variantFirst) return;
      setRoleSlide("award", awardSlides[flavour] || "", "Great Taste 2026");
    }
    if (track) {
      var scrollTick = false;
      track.addEventListener("scroll", function () {
        if (scrollTick) return;
        scrollTick = true;
        requestAnimationFrame(function () { scrollTick = false; markThumb(currentSlide()); });
      }, { passive: true });
    }

    buy.querySelectorAll("[data-opt-idx]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.hasAttribute("disabled")) return;
        var idx = parseInt(btn.getAttribute("data-opt-idx"), 10);
        setPressed(idx, btn.getAttribute("data-opt-value"));
        cascade(idx);
        update();
      });
    });

    var navPrev = section.querySelector("[data-stage-prev]");
    var navNext = section.querySelector("[data-stage-next]");
    function syncNav() {
      var many = slides().length > 1;
      if (navPrev) navPrev.hidden = !many;
      if (navNext) navNext.hidden = !many;
    }
    if (navPrev) navPrev.addEventListener("click", function () { firstJump = false; step(-1); });
    if (navNext) navNext.addEventListener("click", function () { firstJump = false; step(1); });
    if (track) {
      track.addEventListener("keydown", function (e) {
        var k = e.key;
        if (k !== "ArrowLeft" && k !== "ArrowRight" && k !== "Home" && k !== "End") return;
        e.preventDefault();   // otherwise the browser also scrolls the track itself
        firstJump = false;
        if (k === "ArrowLeft") step(-1);
        else if (k === "ArrowRight") step(1);
        // Home/End cross the whole gallery; animating that reads as a rewind, not a jump
        else goTo(k === "Home" ? 0 : slides().length - 1, false, true);
      });
    }
    syncNav();

    section.querySelectorAll("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        if (track) {
          var i = thumbs().indexOf(t);
          if (i < 0) return;   // a hidden thumb must not wrap to the last slide
          firstJump = false;
          goTo(i);
          return;
        }
        section.querySelectorAll("[data-thumb]").forEach(function (x) { x.classList.toggle("active", x === t); });
        setMain(t.getAttribute("data-thumb"), t.getAttribute("aria-label") || "");
      });
    });
    if (variantFirst) { var row0 = section.querySelector("[data-thumbs]"); if (row0) row0.hidden = thumbs().length <= 1; }

    /* The theme's <main> carries a transform, which makes it the containing block for
       position: fixed. The sticky bar was therefore pinned to the bottom of <main>, not
       the viewport — it scrolled with the page and came to rest over the footer. Re-home
       it on <body> so "fixed" means fixed, and publish its height so the theme's floating
       cart button can sit above it instead of on top of Add to cart. */
    var sticky = section.querySelector(".sticky-bar");
    if (sticky && !sticky.closest("[data-s365-sticky-host]")) {
      // Move it inside a .s365 host, not bare onto <body>: the palette lives in custom
      // properties on .s365 and the button styling is scoped `.s365 .cta`, so a bar
      // parented straight to <body> loses both and falls back to the browser's grey.
      var host = document.querySelector("[data-s365-sticky-host]");
      if (!host) {
        host = document.createElement("div");
        host.className = "s365";
        host.setAttribute("data-s365-sticky-host", "");
        host.style.background = "none";
        document.body.appendChild(host);
      }
      // A relocated bar outlives its section, so re-rendering the hero in the theme
      // editor would stack a second one and leave update() writing the price into the
      // stale copy. Keep exactly one, tagged with the section it came from.
      var owner = section.closest(".shopify-section");
      host.replaceChildren(sticky);
      sticky.setAttribute("data-s365-sticky-owner", (owner && owner.id) || "");
    }
    function publishStickyHeight() {
      if (!sticky) return;
      var shown = getComputedStyle(sticky).display !== "none";
      var h = shown ? Math.round(sticky.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty("--s365-sticky-h", h + "px");
    }
    publishStickyHeight();
    window.addEventListener("resize", publishStickyHeight, { passive: true });

    // sticky bar submits the main form
    var form = buy.querySelector("form");
    document.querySelectorAll("[data-sb-submit]").forEach(function (b) {
      b.addEventListener("click", function () { if (form) form.submit(); });
    });

    update();
  }

  function initAll(root) {
    initGeneric(root);
    initParallax();
    initAwards(root);
    var sections = root.querySelectorAll ? Array.prototype.slice.call(root.querySelectorAll(".s365")) : [];
    if (root.classList && root.classList.contains("s365")) sections.push(root);
    sections.forEach(function (s) { initBuy(s); });
  }

  document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  // theme editor: re-init when a section is (re)loaded
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  // removing the hero in the theme editor must not leave an orphaned Add to cart
  document.addEventListener("shopify:section:unload", function (e) {
    var host = document.querySelector("[data-s365-sticky-host]");
    if (!host || !e.target || !e.target.id) return;
    var bar = host.querySelector('[data-s365-sticky-owner="' + e.target.id + '"]');
    if (bar) {
      bar.remove();
      document.documentElement.style.setProperty("--s365-sticky-h", "0px");
    }
  });
})();
